/**
 * DevExtreme (esm/__internal/scheduler/r1/components/wrappers/all_day_table.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import registerComponent from "../../../../../core/component_registrator";
import { AllDayTable } from "../../../../scheduler/r1/components/base/all_day_panel_table";
import { DateTableComponent } from "./date_table";
export class AllDayTableComponent extends DateTableComponent {
  get _propsInfo() {
    return {
      twoWay: [],
      allowNull: [],
      elements: [],
      templates: ["dataCellTemplate"],
      props: ["viewData", "viewContext", "groupOrientation", "leftVirtualCellWidth", "rightVirtualCellWidth", "topVirtualRowHeight", "bottomVirtualRowHeight", "addDateTableClass", "addVerticalSizesClassToRows", "width", "dataCellTemplate"]
    };
  }
  get _viewComponent() {
    return AllDayTable;
  }
}
registerComponent("dxAllDayTable", AllDayTableComponent);